module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "image-viewer__row"
  }, [_c('el-col', {
    staticClass: "image-viewer__col",
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    staticClass: "image-viewer__card",
    attrs: {
      "shadow": "hover",
      "body-style": {
        height: '100%',
        padding: '0px'
      }
    }
  }, [_c('form', {
    ref: "fileform",
    staticClass: "image-viewer__uploader-container"
  }, [(!_vm.currentImage) ? _c('div', {
    staticClass: "image-viewer__uploader"
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("\n            Drop file(s) here or "), _c('em', [_vm._v("click to upload")])])]) : _c('img', {
    staticClass: "image-viewer__img",
    style: ({
      filter: _vm.imageFilter
    }),
    attrs: {
      "src": _vm.currentImage
    }
  })])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f89e5d2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/image-filter/image-editor/image-viewer/image-viewer.vue
// module id = 287
// module chunks = 0